import { getStore } from '../Store'
import Logo from '../assets/Cambrya_Logo.png'
import * as React from 'react';
import { Route, Link, useHistory } from "react-router-dom"; 
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import AppBar from '@mui/material/AppBar';
import CssBaseline from '@mui/material/CssBaseline';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import { Auth } from "../pages/auth/auth";
import NetworkRuns from '../pages/networkRuns';
import AnalyticsFiles from '../pages/heatMapInfo';
import EditNetworkRun from '../pages/networkRuns/EditNetworkRun';
import OutputFiles from '../pages/networkRuns/OutputFiles';
import CreateHeatMap from '../pages/heatMapInfo/CreateHeatMap';
import { SuccessAlert, StatusAlert, ErrorAlert } from '../pages/universal/Alert';
import Audio from '../pages/audio';
import GenerateInputAudio from '../pages/audio/GenerateInputAudio';
import SelectInputAudio from '../pages/audio/SelectInputAudio';
import { observer } from "mobx-react"
import BatchResults from '../pages/batchResults';
import ComparativeSets from '../pages/comparativeSets';
import EditNetworkBatch from '../pages/batchResults/EditNetworkBatch';
import CreateNetworkBatch from '../pages/batchResults/CreateNetworkBatch';
import CreateComparativeSet from '../pages/comparativeSets/CreateComparativeSet';
import EditComparativeSet from '../pages/comparativeSets/EditComparativeSet';
import DensityNetworkConfigs from '../pages/densityNetworkConfigs';
import DensityNetworkConfigParams from '../pages/densityNetworkConfigParams';
import EditDNCParam from '../pages/densityNetworkConfigParams/EditDNCParam';
import PersisterConfigs from '../pages/persisterConfigs';
import GenAlgRuns from '../pages/genAlgRuns';
import ParameterSets from '../pages/densityNetworkConfigParams/ParameterSets';
import EditParameterSet from '../pages/densityNetworkConfigParams/EditParameterSet';
import GenAlgSelectionConfigs from '../pages/genAlgSelectionConfigs';
import CreateGenAlgSelectionConfig from '../pages/genAlgSelectionConfigs/CreateGenAlgSelectionConfig';
import GenAlgAnalyticsFiles from '../pages/genAlgAnalytics';
import EditGenAlgRun from '../pages/genAlgRuns/EditGenAlgRun';
import CreateGenAlgRun from '../pages/genAlgRuns/CreateGenAlgRun';
import EditGenAlgGeneration from '../pages/genAlgRuns/EditGenAlgGeneration';
import EditGenAlgIndividual from '../pages/genAlgRuns/EditGenAlgIndividual';
import EditDensityNetworkConfig from '../pages/densityNetworkConfigs/EditDensityNetworkConfig';
import MergeJSON from '../pages/densityNetworkConfigParams/MergeJSON';
import UnityVisualization from '../pages/unityVisualization';
import UnityBehaviorExploration from '../pages/unityVisualization/UnityBehaviorExploration';
import EditPersisterConfig from '../pages/persisterConfigs/EditPersisterConfig';
import CreateDensityNetworkConfigFromParent from '../pages/densityNetworkConfigs/CreateDensityNetworkConfigFromParent';
import UploadDensityNetworkConfig from '../pages/densityNetworkConfigs/UploadDensityNetworkConfig';
import UploadPersisterConfig from '../pages/persisterConfigs/UploadPersisterConfig';
import ViewComparativeSetDensityNetworkConfigResults from '../pages/comparativeSets/ViewComparativeSetDensityNetworkConfigResults';
import ExtractDNCParamPath from '../pages/densityNetworkConfigParams/ExtractDNCParamPath';
import AboutPage from '../pages/about';
import { signOut } from "firebase/auth";
import { auth } from "../firebase/firebase";

const store = getStore();
const drawerWidth = 200;

const AppMenu = observer((params) => {
    const { push } = useHistory();
    const getCurrentPageFromURL = () => {
        if (window.location.href.includes('unity')) {
            return "Visualization"
        }
        if (window.location.href.includes('batch') || window.location.href.includes('comparative-set') || window.location.href.includes('density-network-config') || window.location.href.includes('persister-config')) {
            return "Batches"
        }
        if (window.location.href.includes('gen-alg')) {
            return "Genetic Exploration"
        }
        if (window.location.href.includes('param')) {
            return "DNC Params"
        }
        else {
            return "Inputs"
        }
    }



    const [currentPage, setCurrentPage] = React.useState(getCurrentPageFromURL());
    //const pages = ['Inputs', 'Visualization', 'Batches', 'Genetic Exploration', 'About'];
    const [pages, setPages] = React.useState(['Inputs'])
    React.useEffect(() => {
        const userRole = store.userRole;
        //console.log("USER_ROLE:")
        //console.log(userRole)
        //console.log(userRole["has_visualization_tab_access"])
        if (userRole["has_visualization_tab_access"]) {
            setPages(pages.push('Visualization'))
        }
        setPages(pages.concat(['Batches', 'Genetic Exploration', 'DNC Params', 'About']))
    }, [])

    const handleSelectPage = (event) => {
        const page = event.currentTarget.id;
        setCurrentPage(page);
        if (page === "Inputs") {
            push('audio-files')
        } else if (page === "Visualization") {
            push('unity-behavior-exploration')
        } else if (page === "Batches") {
            push('batch-results')
        } else if (page === "Genetic Exploration") {
            push('gen-alg-runs')
        } else if (page === "DNC Params") {
            push('dnc-params')
        } else if (page === "About") {
            push('about')
        }
    };


    const currentNetworkRun = store.currentNetworkRun;
    const deselectNetworkRun = () => {
        store.updateCurrentNetworkRun(null)
    }
  
    const successMessage = store.successMessage
    const statusMessage = store.statusMessage
    const errorMessage = store.errorMessage

    if (successMessage != null) {
        store.updateStatusMessage(null)
        setTimeout(function () {
            store.updateSuccessMessage(null)
        }, 5000);
    }

    if (statusMessage != null) {
        setTimeout(function () {
            store.updateStatusMessage(null)
        }, 1000000);
    }

  
    if (errorMessage != null) {
        store.updateStatusMessage(null)
        let timer = setTimeout(function () {
            store.updateErrorMessage(null)
        }, 5000);
    }

    const logout = async () => {
        await signOut(auth);
    }

    return (
    <Box sx={{ display: 'flex' }}>
        <CssBaseline />
        <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
            <Toolbar sx={{ justifyContent: 'space-between' }}>
                <img src={Logo} style={{ width: '40px' }} />
                <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'flex' }, width: '30%' }}>
                    {pages.map((page) => (
                        <Button
                            key={page}
                            id={page}
                            onClick={handleSelectPage}
                            sx={{ my: 2, color: 'white', display: 'block' }}
                        >
                            {page}
                        </Button>
                    ))}
                    </Box>
                    <Box>
                        <Button
                            onClick={() => logout()}
                            sx={{ my: 2, color: 'white', display: 'block' }}
                        >                            
                            LOGOUT
                        </Button>
                    </Box>
            </Toolbar>
        </AppBar>
        <Drawer
            variant="permanent"
            sx={{
                width: drawerWidth,
                flexShrink: 0,
                [`& .MuiDrawer-paper`]: {
                    width: drawerWidth, boxSizing: 'border-box', backgroundColor: params.theme.palette.background.default
                },
            }}
        >
        <Toolbar />
            {currentPage == "Visualization" && <>
                <Box sx={{ overflow: 'auto' }}>
                    <List>
                        {/*<ListItem button component={Link} to="/unity-visualization" onClick={() => deselectNetworkRun()}>*/}
                        {/*  <ListItemText>Unity Visualization</ListItemText>*/}
                        {/*</ListItem>*/}
                        <ListItem button component={Link} to="/unity-behavior-exploration" onClick={() => deselectNetworkRun()}>
                          <ListItemText>Unity Behavior Exploration</ListItemText>
                        </ListItem>
                    </List>
                </Box>
            </>}{currentPage === "Batches" && <>
                <Box sx={{ overflow: 'auto' }}>
                    <List>
                        <ListItem button component={Link} to="/batch-results" onClick={() => deselectNetworkRun()}>
                            <ListItemText>Batches</ListItemText>
                        </ListItem>
                        <ListItem button component={Link} to="/comparative-sets" onClick={() => deselectNetworkRun()}>
                            <ListItemText>Comparative Sets</ListItemText>
                        </ListItem>
                        <ListItem button component={Link} to="/density-network-configs" onClick={() => deselectNetworkRun()}>
                            <ListItemText>Network Configs</ListItemText>
                        </ListItem>
                        <ListItem button component={Link} to="/persister-configs" onClick={() => deselectNetworkRun()}>
                            <ListItemText>Persister Configs</ListItemText>
                        </ListItem>
                    </List>
                </Box>
            </>}
            {currentPage == "Inputs" && <>
                <Box sx={{ overflow: 'auto' }}>
                    <List>
                        <ListItem button component={Link} to="/generate-input-audio" onClick={() => deselectNetworkRun()}>
                            <ListItemText>Generate Input Audio</ListItemText>
                        </ListItem>
                        <ListItem button component={Link} to="/select-input-audio" onClick={() => deselectNetworkRun()}>
                            <ListItemText>Run Density Network</ListItemText>
                        </ListItem>
                        <ListItem button component={Link} to="/audio-files" onClick={() => deselectNetworkRun()}>
                            <ListItemText>Audio File Archive</ListItemText>
                        </ListItem>
                    </List>
                </Box>
                </>}
                {currentPage == "Genetic Exploration" && <>
                    <Box sx={{ overflow: 'auto' }}>
                        <List>
                            <ListItem button component={Link} to="/gen-alg-runs" >
                                <ListItemText>Gen Alg Runs</ListItemText>
                            </ListItem>
                            <ListItem button component={Link} to="/gen-alg-selection-configs" >
                                <ListItemText>Selection Configs</ListItemText>
                            </ListItem>
                        </List>
                    </Box>
                </>}
            {currentPage == "DNC Params" && <>
                <Box sx={{ overflow: 'auto' }}>
                    <List>
                        <ListItem button component={Link} to="/dnc-params" >
                            <ListItemText>DNC Params</ListItemText>
                        </ListItem>
                        <ListItem button component={Link} to="/parameter-sets">
                            <ListItemText>Parameter Sets</ListItemText>
                        </ListItem>
                        <ListItem button component={Link} to="/merge-json">
                            <ListItemText>Merge JSON Test</ListItemText>
                        </ListItem>
                        <ListItem button component={Link} to="/extract-dnc-param-path">
                            <ListItemText>Extract DNC Param Path</ListItemText>
                        </ListItem>
                    </List>
                </Box>
            </>}
        </Drawer>
        <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
            <Toolbar />
            <Route path="/auth" component={Auth} />
            <Route path="/network-runs" component={NetworkRuns} />
            <Route path="/edit-network-batch" component={EditNetworkBatch} />
            <Route path="/create-network-batch" component={CreateNetworkBatch} />
            <Route path="/edit-comparative-set" component={EditComparativeSet} />
            <Route path="/batch-results" component={BatchResults} />
            <Route path="/comparative-sets" component={ComparativeSets} />
            <Route path="/create-comparative-set" component={CreateComparativeSet} />
            <Route path="/comparative-set-density-network-config-results" component={ViewComparativeSetDensityNetworkConfigResults} />
            <Route path="/density-network-configs" component={DensityNetworkConfigs} />
            <Route path="/persister-configs" component={PersisterConfigs} />
            <Route path="/gen-alg-runs" component={GenAlgRuns} />
            <Route path="/parameter-sets" component={ParameterSets} />
            <Route path="/edit-parameter-set" component={EditParameterSet} />
            <Route path="/gen-alg-selection-configs" component={GenAlgSelectionConfigs} />
            <Route path="/dnc-params" component={DensityNetworkConfigParams} />
            <Route path="/edit-dnc-param" component={EditDNCParam} />
            <Route path="/merge-json" component={MergeJSON} />
            <Route path="/extract-dnc-param-path" component={ExtractDNCParamPath} />
            <Route path="/edit-gen-alg-individual" component={EditGenAlgIndividual} />
            <Route path="/edit-gen-alg-generation" component={EditGenAlgGeneration} />
            <Route path="/edit-gen-alg-run" component={EditGenAlgRun} />
            <Route path="/create-gen-alg-selection-config" component={CreateGenAlgSelectionConfig} />
            <Route path="/create-gen-alg-run" component={CreateGenAlgRun} />
            <Route path="/edit-persister-config" component={EditPersisterConfig} />
            <Route path="/edit-density-network-config" component={EditDensityNetworkConfig} />
            <Route path="/create-density-network-config" component={CreateDensityNetworkConfigFromParent} />
            <Route path="/upload-density-network-config" component={UploadDensityNetworkConfig} />
            <Route path="/upload-persister-config" component={UploadPersisterConfig} />
            <Route path="/analytics-files" component={AnalyticsFiles} />
            <Route path="/gen-alg-analytics-files" component={GenAlgAnalyticsFiles} />
            <Route path="/create-heat-map" component={CreateHeatMap} />
            <Route path="/edit-network-run" component={EditNetworkRun} />
            <Route path="/output-files" component={OutputFiles} />
            <Route path="/generate-input-audio" component={GenerateInputAudio} />
            <Route path="/select-input-audio" component={() => (<SelectInputAudio store={getStore()}/>)}/>
            <Route path="/audio-files" component={Audio} />
            <Route path="/unity-visualization" component={UnityVisualization} />
            <Route path="/unity-behavior-exploration" component={UnityBehaviorExploration} />
            <Route path="/about" component={AboutPage} />
        </Box>
        {successMessage && <SuccessAlert message={successMessage}/>}
        {statusMessage && <StatusAlert message={statusMessage} />}
        {errorMessage && <ErrorAlert message={errorMessage}/>}
    </Box>)
});

export { AppMenu };